import { normalizeHref } from "./../../wix-rich-content-common";
import { isPageLink } from "./is-page-link";
const getFullLinkUrl = (link, baseUrl) => isPageLink(link) && baseUrl ? `${baseUrl.replace(/\/+$/, "")}${link.url}` : link.url ? normalizeHref(link.url) || link.url : link.anchor ? `#viewer-${link.anchor}` : void 0;
export {
  getFullLinkUrl
};
//# sourceMappingURL=get-full-link-url.js.map
